import { ready } from './utils.js';

ready(async () => {
  await import('./Nav.js');
  await import('./SecondaryNav.js');
  await import('./LocationResults.js');
  await import('./FadResults.js');
  await import('./Footer.js');
  const { initAccordion } = await import('./Accordion.js');
  initAccordion();
});